import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'

import Button from '@/components/Button'
import Card from '@/components/Card'
import ToolbarIcon from '@/components/images/ToolbarIcon'
import SpaceLanding from '@/components/SpaceLanding'

import messages from './messages'

import './index.scss'

const ToolbarLanding = ({ addToolbar }: any) => {
  const intl = useIntl()

  return (
    <SpaceLanding>
      <SpaceLanding.Header>
        <SpaceLanding.Icon>
          <ToolbarIcon />
        </SpaceLanding.Icon>
        <SpaceLanding.Title componentClass="h1" description={intl.formatMessage(messages.description)}>
          <FormattedMessage {...messages.title} />
        </SpaceLanding.Title>
      </SpaceLanding.Header>
      <SpaceLanding.Body>
        <Card>
          <Card.Header title={<FormattedMessage {...messages.addYourFirst} />} />
          <Card.Content>
            <Button color="primary" onClick={addToolbar}>
              {intl.formatMessage(messages.addAToolbar)}
            </Button>
          </Card.Content>
        </Card>
        <SpaceLanding.Documentation>
          <SpaceLanding.Title description={intl.formatMessage(messages.readDocumentation)}></SpaceLanding.Title>
          <SpaceLanding.Links>
            <SpaceLanding.Link url="https://help.workgrid.com/s/article/Embedding-Workgrid-on-a-Webpage">
              <FormattedMessage {...messages.installation} />
            </SpaceLanding.Link>
          </SpaceLanding.Links>
        </SpaceLanding.Documentation>
      </SpaceLanding.Body>
    </SpaceLanding>
  )
}

ToolbarLanding.displayName = 'ToolbarLanding'

ToolbarLanding.propTypes = {
  /**
   * func to navigate to add new Toolbar
   */
  addToolbar: PropTypes.func.isRequired
}

export default ToolbarLanding
